import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const wrapperCss = css`
    scrollbar-width: none;

    overflow: auto hidden;
    align-items: center;
    justify-content: start;

    height: 100%;

    -ms-overflow-style: none;

    ::-webkit-scrollbar {
        display: none;
    }

    div:not(:first-child) {
        position: relative;
        margin-left: -10px;
    }
`;

export const TooltipName = styled.div`
    ${Fonts.Heading.H600};
    color: ${Colors.WHITE};
`;

export const TooltipId = styled.div`
    ${Fonts.Heading.H800};
    color: ${Colors.WHITE};
`;

export const imgContainerCss = css`
    position: relative;
`;

export const whiteImgCss = css`
    width: 40px;
    height: 40px;
    filter: brightness(0) invert(1);
`;

export const imgCss = css`
    position: absolute;
    top: 0;
    left: 0;

    width: 40px;
    height: 40px;

    opacity: 0.3;

    transition: opacity 0.25s;
`;

export const visibleImgCss = css`
    opacity: 1;
`;

export const hoveredImgCss = css`
    z-index: 1;
`;

export const notHoveredIconCss = css`
    opacity: 0.3;
`;

export const viewMoreTextCss = css`
    margin-left: 5px !important;
`;
